import type { FC } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

interface LogoProps {
  [key: string]: any;
}

const Logo: FC<LogoProps> = () => {
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Typography sx={{ zIndex: 9999999 }} align="center" color="textPrimary" variant={mobileDevice ? 'h6' : 'h5'}>
      Globatech
    </Typography>
  );
};

export default Logo;
